let audio = new Audio();

exports.playAudio = async (scene, lang, voiceSupport) => {
  var audiofilename = '';
  if (voiceSupport) {
    if (lang === 'jp') {
      audiofilename = '02' + scene + '.mp3';
    } else if (lang === 'en') {
      audiofilename = '03' + scene + '.mp3';
    } else if (lang === 'cn') {
      audiofilename = '04' + scene + '.mp3';
    } else if (lang === 'tw') {
      audiofilename = '05' + scene + '.mp3';
    } else {
      audiofilename = '01' + scene + '.mp3';
    }

    try {
      if (audio !== null) this.stopAudio();
    } catch {}

    //audio = new Audio(require('@/assets/audio/'+ scene + '_'+ lang +'.mp3'));
    audio = new Audio(require('@/assets/audio/' + audiofilename));
    audio.load();
    setTimeout(function () {
      // audio.play();
    }, 0);
  }
};

exports.stopAudio = async () => {
  audio.pause();
};
